import React from 'react'
import { Link } from 'react-router-dom'
import {
  hasUserPermission,
  hasUserPermissionOnMegaMenuGroupItem,
} from '../../utils/permissionHelper'

export const lead_funnel = [
  {
    label: 'Lead Providers',
    link: '/lead_provider',
    permission: 'lead_provider_read',
  },
  {
    label: 'Http Request Type',
    link: '/http_request_type',
    permission: 'http_request_type_read',
  },
  {
    label: 'Lead Buy Management',
    link: '/lead_buy_management',
    permission: 'lead_buy_management_read',
  },
  {
    label: 'Inquiry Search',
    link: '/inquiry_search',
    permission: 'inquiry_search',
  },
  {
    label: 'Blocks',
    link: '/lead_funnel_blocks',
    permission: 'lead_funnel_block_read',
  },
  {
    label: 'Block Change Requests',
    link: '/lead_funnel_block_change_requests',
    permission: 'lead_funnel_block_read',
  },
]

export default function NavLeadFunnel(props) {
  return (
    <div className="navbar-dropdown lox-navigation-bar__content__dropdown is-block p-0">
      <div className=" m-0 p-3 is-size-7 lox-navigation-bar__content__dropdown__container">
        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, lead_funnel) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">Lead Funnel</h2>
            {lead_funnel.map(
              (helper) =>
                hasUserPermission(props.userPermissions, helper.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${helper.link}`}
                    onClick={props.onLink}
                    key={helper.permission}
                  >
                    {helper.label}
                  </Link>
                )
            )}
            </div>
        )}
      </div>
    </div>
  )
}
